import {
    CloseButton,
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
} from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { NavHashLink } from "react-router-hash-link";
import { Link } from "react-router-dom";

export default function Example() {
    const [navigation, setNavigation] = useState([
        { name: "HOME", href: "/" },
        { name: "ABOUT", href: "/about" },
        //{ name: "GALLERY", href: "#gallery" },
        { name: "FAQ", href: "/faq" },
        //{ name: "TESTIMONIALS", href: "/#testimonials" },
        { name: "CONTACT US", href: "/contact" },
    ]);

    return (
        <Disclosure
            as="nav"
            className="flex justify-center w-full  text-black top-0 sticky bg-peachDarkPink z-30"
        >
            <div className="h-14 md:px-4 flex justify-between w-full sm:px-3 ">
                <div className="w-full relative flex  items-center justify-between">
                    <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                        {/* Mobile menu button*/}
                        <DisclosureButton className=" group relative inline-flex items-center justify-center rounded-md p-2 text-peachBlack  focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                            <span className="absolute -inset-0.5" />
                            <span className="sr-only">Open main menu</span>
                            <Bars3Icon
                                aria-hidden="true"
                                className="block size-6 group-data-[open]:hidden"
                            />
                            <XMarkIcon
                                aria-hidden="true"
                                className="hidden size-6 group-data-[open]:block"
                            />
                        </DisclosureButton>
                    </div>

                    <div className="flex flex-1 items-center justify-center ">
                        <div className="flex shrink-0 items-center ">
                            <img
                                id="logo"
                                alt="Peaches"
                                src="images/Peachy_Babe_Pocket.png"
                                className="h-8 w-auto hidden"
                            />
                        </div>
                        <div className="hidden sm:ml-6 sm:block ">
                            <div className="flex space-x-4 ">
                                <div className="w-10"></div>
                                {navigation.map((item) => (
                                    <NavHashLink
                                        smooth
                                        id={item.href}
                                        key={item.name}
                                        to={item.href}
                                        className="text-peachBlack  hover:bg-peachGreen hover:text-white rounded-xl px-3 py-2 text-sm font-semibold"
                                    >
                                        {item.name}
                                    </NavHashLink>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0 text-white font-bold tracking-wider ">
                        <button
                            type="button"
                            className="bg-peach px-4 py-2 rounded-xl hover:bg-peachGreen"
                            onClick={() => {
                                window.open(
                                    "https://peachescc.glossgenius.com/services"
                                );
                            }}
                        >
                            Book now
                        </button>
                    </div>
                </div>
            </div>

            <DisclosurePanel className="z-30  sm:hidden absolute top-12 w-screen ">
                {({ close }) => (
                    <div className="   pt-1 bg-peachDarkPink">
                        {navigation.map((item, i) => (
                            <Link
                                key={i}
                                className="  text-peachBlack  block px-3 py-3 text-base font-semibold w-full nav-link-peach"
                                to={item.href}
                                onClick={() => close()}
                            >
                                {item.name}
                            </Link>
                        ))}
                    </div>
                )}
            </DisclosurePanel>
        </Disclosure>
    );
}
